import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — as a registered courier, we handle everything",
      "Ideal for Bike Week and spring break travelers",
      "Perfect for international cruise passengers",
      "Great for Daytona International Speedway event travelers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Volusia County post offices",
      "Good for planned international travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Daytona Beach area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — ~265 miles via I-95",
      "NPIC appointment required before visiting Miami agency",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function DaytonaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Daytona Beach"
      headingExtra="FL"
      introText="Daytona Beach and Volusia County travelers — Bike Week visitors, spring break travelers, Daytona International Speedway event attendees with international travel plans, and Beach Street vacationers — have several options for getting a passport fast. Here is how they compare, and why most Daytona Beach residents choose a U.S. Department of State registered passport courier with guaranteed submission availability at the Miami Passport Agency for fast, professional processing."
      options={options}
      emergencyDescription="Daytona Beach has no regional passport agency. The closest is the Miami Passport Agency at 1501 Biscayne Blvd Suite 210, Miami, FL 33132 — approximately 265 miles via I-95, about 3.5 hours. Florida's single agency serves 22M+ residents. During major events like the Daytona 500, Bike Week, and spring break, I-95 traffic can add hours. Hurricane evacuation traffic (June–November) can turn I-95 into gridlock."
      disclaimerText="*Processing speed depends on eligibility and documentation. Daytona Beach does not have a regional passport agency — the closest is Miami, roughly 265 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}